import React, { useContext, useEffect } from "react";
import AccountContext from "../../context/accounts/accountContext";

import IstavrityContext from "../../context/istavrity/istavrityContext";
import { use } from "react";
import { DepositTemplate } from "../deposits/DepositTemplate";

const DepositExtenal = () => {
  const accountContext = useContext(AccountContext);
  const istavrityContext = useContext(IstavrityContext);
  const {
    getExeternalUserMembers,
    user: { currency },
  } = accountContext;
  const { setDepositItem, deposit_codes, getLastDeposit, getDepositCodes } =
    istavrityContext;
const [members, setMembers] = React.useState([])

useEffect(() => {
    const fetchMembers = async () => {
      const members = await getExeternalUserMembers();
      setMembers(members);
    };
    fetchMembers();
  }, [getExeternalUserMembers]);

  return <div>DepositExtenal

    <DepositTemplate
          members={members}
          currency={currency}
          setDepositItem={setDepositItem}
          deposit_codes={deposit_codes}
          getLastDeposit={getLastDeposit}
          getDepositCodes={getDepositCodes}
            external={true}
        />
  </div>;
};

export default DepositExtenal;
